module.exports = __webpack_public_path__ + "media/images/sandbox/kachel_broschueren-0c1210c06fa34d3dce0bc515c0e2fde2.jpg";